import React from 'react'
import PostProfileImg from "../../../../../styles/img/post-profile-img.jpg"
import GoldenTrophyImg from "../../../../../styles/img/golden-trophy.png"
import PostProfileImgs from "./PostProfileImgs"
import CommentsIcon from "../../../../../styles/img/svg/CommentsIcon.jsx"
import LikeIcon from "../../../../../styles/img/svg/LikeIcon.jsx"
import ShareIcon from "../../../../../styles/img/svg/ShareIcon.jsx"
import ImojiIcon from "../../../../../styles/img/svg/ImojiIcon.jsx"
import ImageIcon from "../../../../../styles/img/svg/ImageIcon.jsx"
import GifIcon from "../../../../../styles/img/svg/GifIcon.jsx"
import ThreeDotIcon from "../../../../../styles/img/svg/ThreeDotIcon.jsx"
import UiCommentInput from "../../../components/form/UiCommentInput"


export default function PostCard(props) {

    return (
        <>
            <div className='sb-post-card'>
                <div className='sb-post-card__wr'>
                    <div className='sb-post-card__top'>
                        <div className='sb-post-card__profile-img'>
                            <img src={PostProfileImg} />
                        </div>
                        <div className='sb-post-card__profile-wr'>
                            <div className='sb-post-card__profile-name'>
                                {props.profileName} 
                            </div>
                            <div className='sb-post-card__profile-status'>
                               {props.status}
                            </div>
                        </div>
                        <div className='sb-post-card__profile-more-icon'>
                            <ThreeDotIcon/>
                        </div>
                    </div>
                    <div className='sb-post-card__post-content'>
                        {props.content}
                        
                    </div>
                    <div className='sb-post-card__post-image'>
                        <img src={GoldenTrophyImg} />
                    </div>
                    <div className='sb-post-card__footer'>
                        <div className='sb-post-card__footer-top'>
                            <div className='sb-post-card__prof-imgs-array'>
                                <PostProfileImgs />
                            </div>
                            <div className='sb-post-card__footer-top-right'>
                                <div className='sb-post-card__comments-count'>
                                    {props.comments} Comments
                                </div>
                                <div className='sb-post-card__shares-count'>
                                    {props.shares} Shares
                                </div>
                            </div>
                        </div>
                        <div className='sb-post-card__footer-center'>
                            <div className='sb-post-card__like'>
                                <LikeIcon /> Like
                            </div>
                            <div className='sb-post-card__comments'>
                                <CommentsIcon />  Comments
                            </div>
                            <div className='sb-post-card__share'>
                                <ShareIcon />  Share
                            </div>
                        </div>
                        <div className='sb-post-card__footer-bottom'>
                            <div className='sb-post-card__write-comment'>
                                <div className='sb-post-card__commenter-img'>
                                    <img src={PostProfileImg} />
                                </div>
                                <div className='sb-post-card__comment-input'>
                                    <UiCommentInput placeholder="Write a comment"/>
                                </div>
                            </div>
                            <div className='sb-post-card__footer-features'>
                                <div className='sb-post-card__feature'>
                                    <GifIcon/>
                                </div>
                                <div className='sb-post-card__feature'>
                                    <ImageIcon/>
                                </div>
                                <div className='sb-post-card__feature'>
                                    <ImojiIcon/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
